export const ADMIN_ADDRESS = "iFnuoqdLigJuY6LTnu1n7pmM88MChVmyR8yMzEWuAa3";
export const PROJECT_VAULT_ADDRESS = "FrE8VcDM7o311Z6HpL23Cn5gKduVEEYxFLVHCV4w6fR6";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const THIVE_TOTAL_SUPPLY = "1000000000000000";
export const THIVE_CONFIG_ID = "main";
export const ADMIN_CREATOR_ADDRESS = "iFnuoqdLigJuY6LTnu1n7pmM88MChVmyR8yMzEWuAa3";
export const AGENT_BASE_COST = "5";
export const AGENT_PER_CAPABILITY_COST = "3";
export const NEW_WALLET_CREDITS = "50";
export const TOPUP_CREDITS = "15";
export const TOPUP_LAMPORTS = "100000000";
export const AGENT_RENTAL_HOURLY_MULTIPLIER = "60";
export const AGENT_RENTAL_DAILY_HOURS_EQUIV = "12";